module.exports = __webpack_public_path__ + "assets/company.ab6b2ebf.svg";